module.exports = __webpack_public_path__ + "img/refusico.1adf032d.gif";